import React from "react";
import {
  Button,
  Iconography,
  IconographySizes,
  IconographyThemes,
  Loader,
  LoaderSizes,
} from "@hid-galaxy-ui/galaxy-react";
import { useNavigate } from "react-router";
import { useAppSelector } from "../../../../../redux";
import "./StatusMessage.scss";

const StatusMessage: React.FC<{}> = () => {
  const { status } = useAppSelector((state) => state.engagement_form);
  const navigate = useNavigate();
  React.useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="engagement-status-message-container">
      {status.submitFormEngagementLoading ? (
        <Loader variant={LoaderSizes.large} />
      ) : status.submitFormEngagementStatus ? (
        <>
          <Iconography
            icon="circleCheck"
            size={IconographySizes.XLarge}
            theme={IconographyThemes.Success}
          />
          <div className="message">Engagement form successfully Submitted</div>
          <Button
            variant="primary"
            label="Continue"
            onClick={() => navigate("/hid-admin/dashboard/engagement-list")}
          />
        </>
      ) : (
        <>
          <Iconography
            icon="circleXmark"
            size={IconographySizes.XLarge}
            theme={IconographyThemes.Error}
          />
          <div className="message">{status.submitFormEngagementMessage || "Something went wrong"}</div>
          <Button
            variant="primary"
            label="Continue"
            onClick={() => navigate("/hid-admin/dashboard/engagement-list")}
          />
        </>
      )}
    </div>
  );
};

export default StatusMessage;
